export const habaProductAdvisor = {
  habaProductAdvisor: {
    title: 'Produkt Berater',
    bannerTitle: 'Powered by Wehrfritz',
    welcome: {
      greetings: 'Hallo ich bin Ihr KI gestützter',
      name: 'Ausstattungs-Berater von Wehrfritz',
      message: 'Wie kann ich Ihnen helfen?',
      description: 'Sie können mich nach Ausstattungsvorschlägen für Bereiche ihrer Einrichtung, Ideen für Möbelkombinationen, aber auch nach konkreten Produkten fragen. Beschreiben Sie einfach Ihr Projekt – hier sind beispielhafte Nachrichten:'
    },
    recommendations: {
      callContactForm: 'Ja, zeige mir die Kontaktmöglichkeiten',
      denyRecommendations: 'Nein, ich möchte selbst schauen',
    },
    chat: {
      yourMessage: 'Ihre Nachricht',
      legalText: 'Legal Text für Datenschutz und Disclaimer, dass die KI Fehler machen kann. Bitte prüfen Sie die Antworten.',
      saveHistory: 'Chatverlauf speichern',
      dimension: {
        length: 'Raumlänge (Meter)',
        width: 'Raumbreite (Meter)'
      },
      templateQuestions: {
        question1: 'Wir möchten in unserem Kindergarten eine 5x5 Meter Bauecke für Kinder einrichten',
        question2: 'Nenne mir Tische und Stühle für den 6x7 Meter großen Kreativraum für unserer Kita',
        question3: 'Ich suche Spiel- und Bastelmaterial für Ostern',
      }
    }
  }
};
